const formRows = [{
    span: 12,
    label: '团队名称',
    component: 'AInput',
    placeholder: '请输入团队名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 12,
    label: '产业分类',
    component: 'ASelect',
    placeholder: '请输入产业分类',
    prop: 'industrialType',
    allowClear: true,
    list: [{
        label: '新一代信息技术产业',
        value: '1'
      },
      {
        label: '生物医药产业',
        value: '3'
      },
      {
        label: '战略性产业集群',
        value: '4'
      },
      {
        label: '新能源汽车产业',
        value: '2'
      },
    ]
  },
  // {
  //   span: 10,
  //   label: '发布日期',
  //   component: 'ADate',
  //   placeholder: '请选择发布日期',
  //   prop: 'publishDate'
  // },
  {
    span: 24,
    label: '照片',
    component: 'AUpload',
    prop: 'picPath' // 首图
  },
  {
    span: 24,
    label: '简介',
    component: 'ATextArea',
    placeholder: '请输入简介',
    prop: 'brief',
    style: {
      height: '78px'
    },
    row: 5,
    allowClear: true
  },
  {
    span: 24,
    label: '研究内容',
    component: 'RichTextEdit',
    prop: 'content'
  },
  {
    span: 24,
    label: '科研结果',
    component: 'EditTable',
    prop: 'techPatents',
    techPatents: [], //表格数据
    columns: [{
        title: '序号',
        dataIndex: 'serialNo',
        width: '80px'
      },
      {
        title: '申请号',
        dataIndex: 'applicationNo',
        scopedSlots: {
          customRender: 'applicationNo'
        }
      },
      {
        title: '专利名称',
        dataIndex: 'name',
        scopedSlots: {
          customRender: 'name'
        }
      },
      {
        title: '申请人',
        dataIndex: 'applicant',
        scopedSlots: {
          customRender: 'applicant'
        }
      },
      {
        title: '发明人',
        dataIndex: 'inventor',
        scopedSlots: {
          customRender: 'inventor'
        }
      },
      {
        title: '公开（公告）号',
        dataIndex: 'publicationNo',
        scopedSlots: {
          customRender: 'publicationNo'
        }
      },
      {
        title: '法律状态',
        dataIndex: 'legalStatus',
        scopedSlots: {
          customRender: 'legalStatus'
        }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: {
          customRender: 'operation'
        }
      }
    ], // 表格
    editArr: [
      'applicationNo',
      'name',
      'applicant',
      'inventor',
      'publicationNo',
      'legalStatus'
    ] // 表格可编辑的字段
  },
  {
    span: 12,
    label: '地址',
    component: 'AInput',
    placeholder: '请输入地址',
    prop: 'address',
    allowClear: true
  },
  {
    span: 12,
    label: '联系人',
    component: 'AInput',
    placeholder: '请输入联系人',
    prop: 'contact',
    allowClear: true
  },
  {
    span: 12,
    label: '联系方式',
    component: 'AInput',
    placeholder: '请输入联系方式',
    prop: 'mobile',
    allowClear: true
  }
]
// var reg = new RegExp(
//   '^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$'
// ) // 校验手机号
const formRules = {
  name: [{
      required: true,
      message: '名称不能为空',
      trigger: 'blur'
    },
    {
      min: 1,
      max: 100,
      message: '输入的字数不能超过100个',
      trigger: 'blur'
    }
  ],
  // mobile: [{
  //     required: false,
  //     message: '联系方式不能为空',
  //     trigger: ['blur']
  //   },
  //   {
  //     validator: (rule, val, callback) => {
  //       console.log(val)
  //       if (!val) return callback()
  //       if (!reg.test(val)) {
  //         callback(new Error('请输入正确的手机号!'))
  //       } else {
  //         callback()
  //       }
  //     }
  //   }
  // ],
  industrialType: [{
    required: true,
    message: '产业分类不能为空',
    trigger: ['blur']
  }],
  brief: [{
    required: true,
    message: '简介不能为空',
    trigger: ['blur']
  }],
  // publishDate: [
  //   { required: true, message: '发布日期不能为空', trigger: ['blur'] }
  // ],
  content: [{
    required: true,
    message: '研究内容不能为空',
    trigger: ['blur']
  }],
  // address: [{
  //   required: false,
  //   message: '地址不能为空',
  //   trigger: ['blur']
  // }],
  // contact: [{
  //   required: false,
  //   message: '联系人不能为空',
  //   trigger: ['blur']
  // }],
  // techPatents: [{
  //     required: false,
  //     message: '科研结果不能为空'
  //   },
  //   {
  //     validator: (rule, val, callback) => {
  //       if (val.length > 0) {
  //         return callback()
  //       }
  //     }
  //   }
  // ]
}

const formInfo = [{
    label: '名称',
    value: '-',
    key: 'name'
  },
  {
    label: '手机号',
    value: '-',
    key: 'mobile'
  },
  {
    label: '产业分类',
    value: '-',
    key: 'industryListStr'
  },
  {
    label: '照片',
    value: '-',
    key: 'picture',
    isVHtml: true
  },
  {
    label: '简介',
    value: '-',
    key: 'brief',
    isVHtml: true
  },
  {
    label: '研究内容',
    value: '-',
    key: 'content',
    isVHtml: true
  },
  {
    label: '联系人',
    value: '-',
    key: 'contact'
  },
  {
    label: '地址',
    value: '-',
    key: 'address'
  },
  {
    label: '科研结果',
    value: [],
    key: 'techPatents',
    columns: [{
        title: '序号',
        dataIndex: 'serialNo',
        width: '80px'
      },
      {
        title: '申请号',
        dataIndex: 'applicationNo'
      },
      {
        title: '专利名称',
        dataIndex: 'name'
      },
      {
        title: '申请人',
        dataIndex: 'applicant'
      },
      {
        title: '发明人',
        dataIndex: 'inventor'
      },
      {
        title: '公开（公告）号',
        dataIndex: 'publicationNo'
      },
      {
        title: '法律状态',
        dataIndex: 'legalStatus'
      }
    ],
    isTable: true
  }
]

module.exports = {
  formRows,
  formRules,
  formInfo
}